import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import envConfig from '~/configs/env'

import prepareAuthHeader from '../headers'
import fastApiParamsSerializer from '../paramsSerializer'

/**
 * Plain `fetchBaseQuery` rather than the demo-mode anonymizing wrapper: conversations, feedback and actions are
 * the assistant's own data, and the surface behaves in demo mode the way the `AssistantBar` does.
 */
const baseQuery = fetchBaseQuery({
  baseUrl: envConfig.serviceUrls.assistant,
  prepareHeaders: prepareAuthHeader,
  paramsSerializer: fastApiParamsSerializer
})

// eslint-disable-next-line import/prefer-default-export
export const api = createApi({
  reducerPath: 'assistantApi',
  baseQuery,
  endpoints: () => ({})
})
